import { createMutationHook } from '~/shared/providers/api';

export const useDeleteFreightLaneMutation = createMutationHook(
  'transportation.freightLaneDelete',
  (params: { id: string }) => ({
    transportationFreightLaneDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
